module.exports = __webpack_public_path__ + "Tenants.61411df3811953b284fdd312e78c62c9.hashedasset.svg";